
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
Vue.config.productionTip = false;
Vue.config.devtools = false;
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example-component', require('./components/ExampleComponent.vue'));
//
const app = new Vue({
    el: '#HausKalkulation',
    data: {
        itemCount: 0,
        items: {},
        datas: {},
    },
    methods: {
        textUpdated(event) {
            let key = event.target.title;
            let item = event.target.value;
            let name = event.target.name;
            if (item > 0) {
                this.$set(this.items, key, item);
                this.$set(this.datas, name, item);

                this.$delete(this.items, "Leer");
            }
            else
            {
                this.$delete(this.items, key);
                this.$delete(this.datas, name);
            }
        }
    },
    watch: {
        items: function () {
            this.itemCount = 0;
            for (var c in this.items) {
                this.itemCount = this.itemCount + 1;
            }
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js